export default "__VITE_ASSET__6f109e6e__"